export const identityPoolId = 'us-east-2:7b19ddd5-e4e4-464e-9549-1bbb03b43ca6'; //Cognito Identity Pool
export const region = 'us-east-2';
export const apiEndpoint = 'https://o09ah11b0c.execute-api.us-east-2.amazonaws.com/prod/Token';